import React from 'react'

export const NothingSelected = () => {
    return (
        <div className="nothing__main-content animate__animated animate__fadeIn animate_faster" >
            <p>Select som ething
                <br/>
                Create an entry
            </p>
            <i className="far fa-star fa-4x mt-3"></i>
        </div>
    )
}
